import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { ContinentDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-continent-container',
  templateUrl: './continent-container.component.html',
  styleUrls: ['./continent-container.component.scss']
})
export class ContinentContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  continents$: Observable<ContinentDto[]>;
  loading: boolean;
  isLoadingContinent$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingContinent$ = this.gatwayFacade.isLoadingGateway("Continent");
    this.continents$ = this.gatwayFacade.loadGateway("Continent");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteContinent(deletedValue: any) {
    this.gatwayFacade.remove("Continent", deletedValue);
  }


// this method control both the create and update

  onSubmitContinent(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Continents;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllContinent = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllContinent.push(pullData[i]);
    }
  }

// check if the addAllContinent array is not empty, then dispatch the data to the store
   if(addAllContinent.length > 0) {
    this.gatwayFacade.add('Continent', addAllContinent);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('Continent', allUpdates, ['id']);
  }

   }


}
